export default {
  computed: {
    focusClass() {
      return { ["is-focused"]: this.focused_ };
    },
    isFocused() {
      return this.focused_;
    },
  },
  data() {
    return {
      focused_: false,
    };
  },
};
